import { ReactElement } from 'react';
import { PendingLeadsListPage } from './pendingLeadsList';

export const PendingLeadsList = (): ReactElement => {
	return <PendingLeadsListPage />;
};
